/**
 * nf-locations.js
 * Google Maps integration + search/filter for the Our Locations page.
 * Also handles the single-store map on individual store detail pages.
 */
(function () {
  'use strict';

  var map, markers = [], infoWindow;
  var stores = [];
  var currentRegion = 'all';
  var currentQuery  = '';

  function getApiKey() {
    var el = document.getElementById('nf-loc-map') || document.getElementById('nf-sd-map');
    return el ? (el.getAttribute('data-api-key') || '') : '';
  }

  function loadMapsApi(key) {
    if (window.google && window.google.maps) {
      window.nfMapsReady();
      return;
    }
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key='
      + encodeURIComponent(key) + '&callback=nfMapsReady';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }

  var MAP_STYLES = [
    { featureType: 'poi',     elementType: 'labels',          stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', elementType: 'labels.icon',     stylers: [{ visibility: 'off' }] },
    { elementType: 'geometry',                                 stylers: [{ color: '#f5f3ef' }] },
    { featureType: 'road',    elementType: 'geometry',        stylers: [{ color: '#ffffff' }] },
    { featureType: 'road',    elementType: 'labels.text.fill',stylers: [{ color: '#999999' }] },
    { featureType: 'water',   elementType: 'geometry',        stylers: [{ color: '#c9e2f0' }] },
    { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ color: '#ede9e3' }] }
  ];

  var MARKER_ICON_NORMAL = {
    path: 'M 0,-10 C -5.5,-10 -10,-5.5 -10,0 C -10,6 0,16 0,16 C 0,16 10,6 10,0 C 10,-5.5 5.5,-10 0,-10 Z',
    fillColor: '#1D4937',
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2,
    scale: 1,
    anchor: null
  };

  // ── Main locations page ────────────────────────────────────────────────────
  function initLocationsMap() {
    var container = document.getElementById('nf-loc-map');
    if (!container) return;

    var dataEl = document.getElementById('nf-store-data');
    if (dataEl) {
      try { stores = JSON.parse(dataEl.textContent); } catch (e) { stores = []; }
    }

    map = new google.maps.Map(container, {
      center: { lat: 40.74, lng: -73.97 },
      zoom: 11,
      styles: MAP_STYLES,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP }
    });

    infoWindow = new google.maps.InfoWindow({ maxWidth: 240 });

    MARKER_ICON_NORMAL.anchor = new google.maps.Point(0, 16);

    stores.forEach(function (store, i) {
      if (!store.lat || !store.lng) return;
      var marker = new google.maps.Marker({
        position: { lat: store.lat, lng: store.lng },
        map: map,
        title: store.name,
        icon: {
          path: 'M 0,-10 C -5.5,-10 -10,-5.5 -10,0 C -10,6 0,16 0,16 C 0,16 10,6 10,0 C 10,-5.5 5.5,-10 0,-10 Z',
          fillColor: '#1D4937',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          scale: 1,
          anchor: new google.maps.Point(0, 16)
        }
      });
      marker.storeIdx = i;
      marker.addListener('click', function () {
        var s = stores[marker.storeIdx];
        var content =
          '<div style="font-family:inherit;padding:6px 4px;max-width:200px;">' +
          '<strong style="color:#1D4937;font-size:0.85rem;display:block;margin-bottom:4px;">' +
          escHtml(s.neighborhood || s.name) + '</strong>' +
          '<span style="font-size:0.76rem;color:#555;">' + escHtml(s.address.replace(/\n/g, ', ')) + '</span>' +
          (s.local_delivery
            ? '<div style="margin-top:5px;font-size:0.7rem;color:#1D4937;font-weight:700;">&#128666; Local Delivery</div>'
            : '') +
          (s.page_url
            ? '<a href="' + escHtml(s.page_url) + '" style="display:inline-block;margin-top:8px;font-size:0.76rem;color:#1D4937;font-weight:600;text-decoration:none;">More Info &rarr;</a>'
            : '') +
          '</div>';
        infoWindow.setContent(content);
        infoWindow.open(map, marker);
      });
      markers.push(marker);
    });

    fitVisible();
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fitVisible() {
    if (!map) return;
    var bounds = new google.maps.LatLngBounds();
    var count = 0;
    markers.forEach(function (m) {
      if (m.getVisible()) { bounds.extend(m.getPosition()); count++; }
    });
    if (count === 0) return;
    map.fitBounds(bounds);
    // Don't over-zoom a single result
    if (count === 1) {
      google.maps.event.addListenerOnce(map, 'idle', function () {
        if (map.getZoom() > 15) map.setZoom(15);
      });
    }
  }

  function applyFilter() {
    var q = currentQuery;
    var r = currentRegion;
    var cards = document.querySelectorAll('.nf-loc__card');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var name = (card.getAttribute('data-name')    || '').toLowerCase();
      var addr = (card.getAttribute('data-address') || '').toLowerCase();
      var reg  = (card.getAttribute('data-region')  || '').toLowerCase();

      var kw     = (card.getAttribute('data-keywords') || '').toLowerCase();
      var matchQ = !q || name.indexOf(q) !== -1 || addr.indexOf(q) !== -1 || kw.indexOf(q) !== -1;
      var matchR = r === 'all' || reg === r;

      if (matchQ && matchR) { card.removeAttribute('hidden'); visibleCount++; }
      else                  { card.setAttribute('hidden', ''); }
    });

    var noRes = document.querySelector('.nf-loc__no-results');
    if (noRes) noRes.classList.toggle('is-visible', visibleCount === 0);

    markers.forEach(function (m) {
      var s = stores[m.storeIdx];
      if (!s) return;
      var name = (s.name    || '').toLowerCase();
      var addr = (s.address || '').toLowerCase();
      var reg  = (s.region  || '').toLowerCase();
      var matchQ = !q || name.indexOf(q) !== -1 || addr.indexOf(q) !== -1;
      var matchR = r === 'all' || reg === r;
      m.setVisible(matchQ && matchR);
    });

    fitVisible();
  }

  // ── Store detail page ──────────────────────────────────────────────────────
  function initStoreDetailMap() {
    var container = document.getElementById('nf-sd-map');
    if (!container) return;

    var lat  = parseFloat(container.getAttribute('data-lat') || '');
    var lng  = parseFloat(container.getAttribute('data-lng') || '');
    var name = container.getAttribute('data-name') || 'Nuts Factory';

    if (!lat || !lng) return;

    var sdMap = new google.maps.Map(container, {
      center: { lat: lat, lng: lng },
      zoom: 16,
      styles: MAP_STYLES,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP }
    });

    var marker = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: sdMap,
      title: name,
      icon: {
        path: 'M 0,-12 C -6.5,-12 -12,-6.5 -12,0 C -12,7 0,19 0,19 C 0,19 12,7 12,0 C 12,-6.5 6.5,-12 0,-12 Z',
        fillColor: '#1D4937',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2.5,
        scale: 1,
        anchor: new google.maps.Point(0, 19)
      }
    });

    var iw = new google.maps.InfoWindow({
      content: '<div style="font-family:inherit;padding:4px 4px;"><strong style="color:#1D4937;font-size:0.9rem;">' + escHtml(name) + '</strong></div>'
    });
    iw.open(sdMap, marker);
  }

  // ── Entry point (called by Maps API async callback) ────────────────────────
  window.nfMapsReady = function () {
    initLocationsMap();
    initStoreDetailMap();

    // Wire up search input
    var input = document.getElementById('nf-loc-search');
    if (input) {
      input.addEventListener('input', function () {
        currentQuery = this.value.toLowerCase().trim();
        applyFilter();
      });
    }

    // Wire up region filter buttons
    document.querySelectorAll('.nf-loc__filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.nf-loc__filter-btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        this.classList.add('is-active');
        currentRegion = this.getAttribute('data-region') || 'all';
        applyFilter();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    var key = getApiKey();
    if (!key) return;
    loadMapsApi(key);
  });

})();
